<template>
    <el-dialog
        :title="po.netForm.id > 0 ? '编辑销售网络' : '新增销售网络'"
        v-model="po.show"
        append-to-body
        :close-on-click-modal="false"
        width="50%"
        :before-close="close"
    >
        <el-form :model="po.netForm" ref="poFormRef" label-width="120px" :rules="rules">
            <el-form-item prop="uid" label="业务经理">
                <el-select v-model="po.netForm.uid" placeholder="请选择" @change="handleUser">
                    <el-option
                        :key="item.id"
                        :label="item.realname + '-' + item.username"
                        :value="item.id"
                        v-for="item in po.managers"
                    />
                </el-select>
            </el-form-item>
            <el-form-item prop="company_name" label="公司名">
                <el-input v-model="po.netForm.company_name" autocomplete="off" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item prop="phone" label="联系电话">
                <el-input v-model="po.netForm.phone" autocomplete="off" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item prop="contactor" label="联系人">
                <el-input v-model="po.netForm.contactor" autocomplete="off" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item prop="isVip" label="VIP">
                <el-radio-group v-model="po.netForm.isVip">
                    <el-radio-button :label="1">是</el-radio-button>
                    <el-radio-button :label="0">否</el-radio-button>
                </el-radio-group>
            </el-form-item>
            <el-form-item prop="sort" label="排序">
                <el-input v-model="po.netForm.sort" autocomplete="off" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="省市区">
                <div class="flex">
                    <el-select
                        v-model="po.netForm.provinceId"
                        clearable
                        placeholder="请选择省"
                        @change="handleProvince"
                    >
                        <el-option
                            v-for="item in po.provinceLists"
                            :key="item.region_id"
                            :label="item.region_name"
                            :value="item.region_id"
                        />
                    </el-select>
                    <el-select v-model="po.netForm.cityId" clearable placeholder="请选择市" @change="handleCity">
                        <el-option
                            v-for="item in po.cityLists"
                            :key="item.region_id"
                            :label="item.region_name"
                            :value="item.region_id"
                        />
                    </el-select>
                    <el-select
                        v-model="po.netForm.districtId"
                        clearable
                        placeholder="请选择区"
                        @change="handleDistrict"
                    >
                        <el-option
                            v-for="item in po.districtLists"
                            :key="item.region_id"
                            :label="item.region_name"
                            :value="item.region_id"
                        />
                    </el-select>
                </div>
            </el-form-item>
            <el-form-item prop="address" label="详细地址">
                <el-input v-model="po.netForm.address" autocomplete="off" placeholder="请输入"></el-input>
            </el-form-item>
        </el-form>
        <template #footer>
            <el-button @click="resetForm(poFormRef)">取 消</el-button>
            <el-button type="primary" @click="submitForm">确 认</el-button>
        </template>
    </el-dialog>
</template>
<script setup>
import request from '@/request/index.js';
import { ElMessage } from 'element-plus';
import { reactive, ref, onMounted, watch } from 'vue';
import { requestDomain } from '../../../../package.json';
import { Plus, Delete } from '@element-plus/icons-vue';
const props = defineProps({
    visible: Boolean,
    saleId: Number
});
const emit = defineEmits(['parentCallback', 'closeDialog']);

const poFormRef = ref();

const rules = reactive({
    address: [{ required: true, trigger: 'change', message: '请输入详细地址' }],
    company_name: [{ required: true, trigger: 'change', message: '请输入公司名称' }],
    phone: [{ required: true, trigger: 'change', message: '请输入联系电话' }],
    province: [{ required: true, trigger: 'change', message: '请选择省' }],
    city: [{ required: true, trigger: 'change', message: '请选择市' }],
    district: [{ required: true, trigger: 'change', message: '请选择区' }]
});

let po = reactive({
    show: false,
    netForm: {
        id: 0,
        phone: '',
        company_name: '',
        address: '',
        contactor: '',
        province: '',
        city: '',
        district: '',
        provinceId: '',
        cityId: '',
        districtId: '',
        uid: 0,
        isVip: 1,
        sort: 0
    },
    provinceLists: [],
    cityLists: [],
    districtLists: [],
    layoutJSON: [],
    managers: []
});

const handleUser = e => {
    const tempUser = po.managers.find(item => item.id === e);
    console.log(e, 'st');
    po.netForm.isVip = tempUser ? tempUser.isVip : 0;
};
const getSaleDetail = async () => {
    const rsp = await request('fetchSaleNet', { id: props.saleId });
    if (rsp.status === 200) {
        const rspData = rsp.data;
        await fetchAreaLists(rspData.provinceId, 'c');
        await fetchAreaLists(rspData.cityId, 'd');
        setTimeout(() => {
            po.netForm = rspData;
            console.log(po.netForm, 'po.netForm');
            po.show = props.visible;
        }, 500);
    }
};
if (props.saleId > 0) {
    getSaleDetail();
} else {
    po.show = true;
}
const handleProvince = () => {
    po.cityLists = [];
    po.netForm.city = '';
    po.netForm.cityId = '';
    const tempProvince = po.provinceLists.find(item => item.region_id === po.netForm.provinceId);
    po.netForm.province = tempProvince.region_name;
    fetchAreaLists(po.netForm.provinceId, 'c');
};
const handleCity = () => {
    po.districtLists = [];
    po.netForm.district = '';
    po.netForm.districtId = '';
    const tempCity = po.cityLists.find(item => item.region_id === po.netForm.cityId);
    po.netForm.city = tempCity.region_name;
    fetchAreaLists(po.netForm.cityId, 'd');
};
const handleDistrict = () => {
    const tempDistrict = po.districtLists.find(item => item.region_id === po.netForm.districtId);
    po.netForm.district = tempDistrict.region_name;
};
const fetchAreaLists = async (pid, type) => {
    const rsp = await request('areaLists', { parent_id: pid });
    if (rsp.status === 200) {
        const dataLists = rsp.data.list;
        if (type === 'p') {
            po.provinceLists = dataLists;
        } else if (type === 'c') {
            po.cityLists = dataLists;
        } else if (type === 'd') {
            po.districtLists = dataLists;
        }
    }
};
fetchAreaLists(1, 'p');
const submitForm = () => {
    poFormRef.value.validate(async valid => {
        if (valid) {
            const requestMethod = po.netForm.id !== 0 ? 'updateSaleNet' : 'addSaleNet';
            const result = await request(requestMethod, po.netForm);
            if (result.status === 200) {
                ElMessage({ message: result.msg, type: 'success' });
            }
            emit('parentCallback');
        } else {
            console.log('error submit!');
            return false;
        }
    });
};
const close = () => {
    emit('closeDialog');
};
const resetForm = poFormRef => {
    poFormRef.resetFields();
    close();
};
const queryInitHandler = async function () {
    const result = await request('queryUserLists', { level: 1 });
    const list = result.data.list;
    po.managers = list;
};
queryInitHandler();
</script>
<style lang="scss">
.multi-imgs .el-upload-list__item {
    display: none;
}
.selected-role__list {
    width: 100%;
    margin-bottom: 8px;
    flex-wrap: wrap;
}
.mgr {
    margin-right: 8px;
}
.mgt {
    margin-top: 8px;
}
.cascader-lists {
    width: 100%;
}
</style>
